import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalVariadoService } from 'src/app/core/services/modal-variado/modal-variado.service';
import { RequestService } from 'src/app/core/services/request/request.service';

@Component({
  selector: 'app-multibeneficiario',
  templateUrl: './multibeneficiario.component.html',
  styleUrls: ['./multibeneficiario.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class MultiBeneficiarioComponent implements OnInit {
  data: any;
  documentosConArchivos: any[] = [];
  private blobStorageBaseUrl: string = 'https://colsstoragedigitalpru.blob.core.windows.net/requests/';
  panelVisibility: boolean[] = [];
  allDocumentsUploaded: boolean[] = [false,false];
  nombreTitular: string = '';

  constructor(private route: ActivatedRoute, 
    public requestService: RequestService,     public _ModalVariadoService: ModalVariadoService,) { }

    ngOnInit(): void {
      const navigation = window.history.state;
      this.data = navigation?.['data'] || null;

      if (this.data?.documentos) {
        this.panelVisibility = new Array(Object.keys(this.data.documentos).length).fill(true);
      } else {
        this.panelVisibility = [];
      }
      this.nombreTitular = this.data ? this.obtenerNombresApellidosTitular(this.data) : '';
    }
    

  getBlobUrl(fileName: string): string {
    return `${this.blobStorageBaseUrl}${fileName}?nocache=${new Date().getTime()}`;
  }


  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }
  
  enviarTodosDocumentos(index: number, key: any): void {
    if (this.documentosConArchivos.length === 0) {
      alert('Por favor seleccione al menos un archivo para enviar.');
      return;
    }

    
    this.data.documentos[key].documentos.forEach(documento => {
      this.enviarDocumento(documento);
      this.panelVisibility[index] = false;
    });

    if(this.panelVisibility[index] == false ){
      this._ModalVariadoService.modalConfirmacion("documentos enviados con éxito");
    }
  }

  enviarDocumento(documento: any): void {
    if (!documento.selectedFile) {
      alert('Por favor seleccione un archivo.');
      return;
    }

    this.requestService.actualizarDocumento(documento.documento.id, documento.documento.url, documento.selectedFile)
    .subscribe({
      next: (response: any) => {
        console.log('Respuesta completa del servidor:', response); // 🔍 Debugging

        if (response?.status === 200 || response?.status === 'success') {
          let documentUrl: string | null = null;
  
          if (typeof response === 'string') {
            const urlMatch = response.match(/URL: (.+)/);
            documentUrl = urlMatch ? urlMatch[1] : null;
          } else if (response?.url) {
            documentUrl = response.url;
          }
  
          if (documentUrl) {
            console.log('Documento actualizado correctamente. URL:', documentUrl);
          } else {
            alert('Documento actualizado, pero no se pudo obtener la URL.');
          }
        } else {
          alert('El servidor respondió, pero no fue exitoso.');
          console.error('Respuesta inesperada:', response);
        }
      },
      error: (err: any) => {
 
      }
    });
  
  }

  checkAllDocumentsUploaded(key: string, index: number) {
    const allUploaded = this.data.documentos[key].documentos.every(doc => doc.selectedFile);
    this.allDocumentsUploaded[index] = allUploaded;
  }

  onFileSelected(event: any, documento: any, key: string, i: number) {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      documento.selectedFile = file;

      const index = this.documentosConArchivos.findIndex(d => d.id === documento.id);
      if (index === -1) {
        this.documentosConArchivos.push(documento);
      } else {
        this.documentosConArchivos[index] = documento;
      }

      this.checkAllDocumentsUploaded(key,i);
    } else {
      alert('Solo se permiten archivos PDF.');
    }
  }

  removeFile(documento: any, fileInput: any, key: string, i:number) {
    documento.selectedFile = null;
    fileInput.value = null;

    const index = this.documentosConArchivos.findIndex(d => d.id === documento.id);
    if (index !== -1) {
      this.documentosConArchivos.splice(index, 1);
    }

    this.checkAllDocumentsUploaded(key,i);
  }

  obtenerNombresApellidosTitular(data: any): string {
    const documentosKeys = Object.keys(data.documentos);
  
    if (documentosKeys.length === 0) {
      return "";
    }
  
    const primeraClave = documentosKeys[0];
    const solicitud = data.documentos[primeraClave].documentos[0].documento.solicitudesComplementosEntity.solicitudesEntity;
  
    const primerNombre = solicitud && solicitud.primerNombreTitular ? solicitud.primerNombreTitular : "";
    const segundoNombre = solicitud && solicitud.segundoNombreTitular ? solicitud.segundoNombreTitular : "";
    const primerApellido = solicitud && solicitud.primerApellidoTitular ? solicitud.primerApellidoTitular : "";
    const segundoApellido = solicitud && solicitud.segundoApellidoTitular ? solicitud.segundoApellidoTitular : "";
  
    return `${primerNombre} ${segundoNombre} ${primerApellido} ${segundoApellido}`.trim();
  }
}
